<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ODBUS Operator Privacy Policy</title>

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
      rel="stylesheet"
    />
  </head>

  <body>
    <section class="hero">
      <div class="container text-center">
        <h1>ODBUS Operator Privacy Policy</h1>
        <p class="lead mt-3">
          Your privacy and operational data security are important to us.
        </p>

        <span class="last-updated"> Last Updated: 10 July 2026 </span>
      </div>
    </section>

    <div class="container my-5">
      <div class="row">
        <div class="col-lg-3">
          <div class="toc">
            <h5>Contents</h5>

            <a href="#1-1">1.1 Introduction</a>
            <a href="#1-2">1.2 Information We Collect</a>
            <a href="#1-3">1.3 How We Use Information</a>
            <a href="#1-4">1.4 User Accounts</a>
            <a href="#1-5">1.5 Data Security</a>
            <a href="#1-6">1.6 Third-Party Services</a>
            <a href="#1-7">1.7 Data Retention</a>
            <a href="#1-8">1.8 Operator Responsibilities</a>
            <a href="#1-9">1.9 Children's Privacy</a>
            <a href="#1-10">1.10 Changes to Policy</a>
            <a href="#1-11">1.11 Contact Information</a>
            <a href="#1-12">1.12 Consent</a>
          </div>
        </div>

        <div class="col-lg-9">
          <div class="policy-card">
            <section id="1-1" class="section">
              <h2>1.1 Introduction</h2>

              <p>
                This Privacy Policy explains how
                <strong>ODBUS</strong> ("ODBUS," "we," "us," or "our") collects,
                uses, stores, and protects information in connection with the
                <strong>ODBUS Operator Mobile Application</strong>.
              </p>

              <p>
                The App is provided exclusively to authorized bus operators who
                are registered partners of ODBUS.
              </p>

              <p>
                By accessing or using the App, you agree to the collection and
                use of information in accordance with this Privacy Policy.
              </p>

              <p>
                This Privacy Policy applies only to the App and does not apply
                to other ODBUS websites, applications, or services, which may
                have separate privacy policies.
              </p>
            </section>

            <section id="1-2" class="section">
              <h2>1.2 Information We Collect</h2>

              <p>We collect the following categories of information:</p>

              <ul>
                <li>
                  <strong>Account Information</strong><br />
                  Login credentials, operator ID, contact number, and business
                  details.
                </li>

                <li>
                  <strong>Operational Data</strong><br />
                  Seat management, fare change requests, cancellation requests,
                  and other actions.
                </li>

                <li>
                  <strong>Booking Related Data</strong><br />
                  Booking and cancellation information relevant to your
                  services.
                </li>

                <li>
                  <strong>Device & Technical Information</strong><br />
                  Device type, operating system, IP address, device identifiers,
                  application version, and crash logs.
                </li>

                <li>
                  <strong>Usage Data</strong><br />
                  Login timestamps, features used, and session duration.
                </li>
              </ul>

              <p>
                We collect only the information necessary to operate and improve
                the App.
              </p>
            </section>

            <section id="1-3" class="section">
              <h2>1.3 How We Use Information</h2>

              <ul>
                <li>Authenticate operators securely.</li>
                <li>Provide booking and seat management features.</li>
                <li>Maintain accurate inventory.</li>
                <li>Provide operator support.</li>
                <li>Prevent fraud and misuse.</li>
                <li>Comply with legal obligations.</li>
                <li>Communicate service updates.</li>
              </ul>

              <p>
                We never sell operator data or use it for third-party
                advertising.
              </p>
            </section>

            <section id="1-4" class="section">
              <h2>1.4 User Accounts</h2>

              <p>
                Access requires an operator account issued by ODBUS. You are
                responsible for maintaining the confidentiality of your login
                credentials and must notify ODBUS immediately if unauthorized
                access is suspected.
              </p>
            </section>

            <section id="1-5" class="section">
              <h2>1.5 Data Security</h2>

              <p>
                We implement reasonable administrative, technical, and physical
                safeguards including encrypted communication, secure
                infrastructure, and access controls.
              </p>

              <p>
                While we strive to protect your information, no electronic
                transmission or storage system can be guaranteed to be
                completely secure.
              </p>
            </section>

            <section id="1-6" class="section">
              <h2>1.6 Third-Party Services</h2>

              <p>
                We may use trusted third-party providers such as cloud hosting,
                analytics, and crash reporting services solely to support App
                functionality.
              </p>

              <p>
                These providers are contractually obligated to protect your
                information and cannot use it for independent purposes.
              </p>
            </section>

            <section id="1-7" class="section">
              <h2>1.7 Data Retention</h2>

              <p>
                Operator account information is retained while your account
                remains active and for a reasonable period thereafter to comply
                with legal and operational requirements.
              </p>
            </section>

            <section id="1-8" class="section">
              <h2>1.8 Operator Responsibilities</h2>

              <ul>
                <li>Ensure submitted information is accurate.</li>

                <li>Use the App only for legitimate operational purposes.</li>

                <li>Protect login credentials.</li>

                <li>
                  Report unauthorized access or suspected breaches immediately.
                </li>
              </ul>
            </section>

            <section id="1-9" class="section">
              <h2>1.9 Children's Privacy</h2>

              <p>
                The App is intended only for authorized adult bus operators and
                their staff. It is not intended for individuals under the age of
                18.
              </p>
            </section>

            <section id="1-10" class="section">
              <h2>1.10 Changes to Policy</h2>

              <p>
                We may update this Privacy Policy periodically to reflect
                changes in our services, legal obligations, or operational
                practices.
              </p>
            </section>

            <section id="1-11" class="section">
              <h2>1.11 Contact Information</h2>

              <div class="contact-box">
                <strong>ODBUS Support</strong>

                <p class="mb-2 mt-3">📧 support@odbus.in</p>

                <p class="mb-0">📞 +91 95839 18888</p>
              </div>
            </section>

            <section id="1-12" class="section">
              <h2>1.12 Consent</h2>

              <p>
                By creating an account, logging into, or otherwise using the
                ODBUS Operator App, you acknowledge that you have read,
                understood, and agreed to this Privacy Policy and consent to the
                collection, use, and processing of information as described
                herein.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>

    <footer class="text-center">© {{ currentYear }} ODBUS. All Rights Reserved.</footer>

    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
  </body>
</html>
